<template>
    <div>

        <div id="catalog--show" v-if="item">
            <div class="container">

                <b-breadcrumb :items="filter.state.breadcrumb"></b-breadcrumb>

                <div class="row">
                    <div class="d-none d-xl-block col-xl-3">
                        <catalog-categories></catalog-categories>
                    </div>
                    <div class="col-xl-9 position-relative">
                        <div class="catalog--show__container mb-40">

                            <div>
                                <div class="row justify-content-center mb-64 show-row">
                                    <div class="mb-5 mb-lg-0 col-10 col-sm-8 col-md-10 col-lg-6">
                                        <img v-if="item.discount_flag != 0" src="/img/logo_skidka2.ico" class="discount-img">
                                        <b-carousel
                                            id="carousel"
                                            :interval="0"
                                            fade
                                            v-model="slide"
                                            :controls="true ? item_images.length > 1 : false">
                                            <b-carousel-slide v-for="(image, i) in item_images" :key="i"
                                                              class="cursor-pointer"
                                                              v-b-modal.showProductImage>
                                                <template #img>
                                                    <img
                                                        class="d-block img-fluid w-100"
                                                        :src="'https://app.skybase.ru/public/actions/39947490820098?fileid=' + item.code + image"
                                                        :alt="(item.h1 ?? item.name) + ' взять в аренду в Москве'"
                                                    >
                                                </template>
                                            </b-carousel-slide>
                                        </b-carousel>

                                        <div class="carousel-navigation">
                                            <div v-for="(image, i) in item_images" :key="i"
                                                 class="carousel-navigation__item"
                                                 :class="{'active': slide == i}"
                                                 @click="slideTo(i)">
                                                <img
                                                    :src="'https://app.skybase.ru/public/actions/39947490820098?fileid=' + item.code + image"
                                                    :alt="(item.h1 ?? item.name) + ' взять в аренду в Москве'"
                                                    class="img-fluid">
                                            </div>
                                        </div>


                                    </div>
                                    <div class="col-lg-6">
                                        <h1 class="as-h2 mb-20">{{item.h1 ?? item.name}}</h1>

                                        <div class="mb-32 small_desc d-md-block d-none" v-html="item.small_desc"></div>

                                        <!--                                        <div class="price-box">-->
                                        <!--                                            <h5 class="price">{{item.day_price}} RUB / день</h5>-->
                                        <!--                                            <h5 class="price">{{item.threeHoure_price}} RUB / 3 часа</h5>-->
                                        <!--                                        </div>-->

                                        <div class="price-card" v-if="item.discount_flag == 0">
                                            <div class="title-3 font-500 mb-8">Тарифы аренды</div>
                                            <div class="title-4 mb-1 d-flex align-items-center justify-content-between">
                                                <span class="color-text-grey font-500">Сутки</span>
                                                <span class="font-700">{{item.day_price}} RUB</span>
                                            </div>
                                            <div class="title-4 font-500 mb-8" v-if="item.not_apply_discount != 0">*Скидка не распространяется</div>
                                        </div>

                                        <div class="price-card" v-else>
                                            <div class="title-3 font-500 mb-8">Тарифы аренды</div>
                                            <div class="title-4 mb-1 d-flex align-items-center justify-content-between">
                                                <span class="color-text-grey font-500">Новая цена</span>
                                                <span class="font-700">{{item.discount_new_price}} RUB/сутки</span>
                                            </div>
                                            <div class="title-4 mb-0 d-flex align-items-center justify-content-between">
                                                <span class="color-text-grey font-500">Старая цена</span>
                                                <span
                                                    class="font-700 old-price">{{item.discount_old_price}} RUB/сутки</span>
                                            </div>
                                            <div class="title-4 font-500 mb-8">*Накопительная скидка и скидка от промокода на акционный товар не распространяется</div>
                                        </div>

                                        <div
                                            class="d-flex flex-column flex-sm-row d-md-none pt-4 mb-5 justify-content-center">
                                            <button class="button btn-large btn-v2 mr-sm-1 mb-3 mb-sm-0"
                                                    v-if="itemFromBasket">Товар в
                                                корзине
                                            </button>
                                            <button id="button_mobile" class="Vkorziny button btn-large btn-v2 mr-1 mb-3 mb-sm-0"
                                                    v-else
                                                    @click="addToBasket('show_modal')">Добавить в корзину
                                            </button>

                                            <button class="button btn-large btn-v1 ml-sm-1" @click="makeOrder()">
                                                Оформить заказ
                                            </button>
                                        </div>

                                        <div class="mb-32 small_desc d-block d-md-none" v-html="item.small_desc"></div>

                                    </div>
                                </div>

                                <div class="delivery-box" v-if="delivery">
                                    <div class="delivery-box__item" v-for="point in delivery">
                                        <div class="d-flex align-items-center">
                                            <img :src="'/storage/' + point.image" alt="" class="mr-2">
                                            <span class="title-4">{{point.text}}</span>
                                        </div>

                                        <div class="title-4 delivery-price">{{point.price}}</div>
                                    </div>

                                    <div class="delivery-box__item">
                                        <div class="d-flex align-items-center">
                                            <img src="/img/icons/cash_on_delivery.png" alt="" class="mr-2">
                                            <router-link class="delivery-link" to="/delivery">
                                                <span class="title-4">Доставка и оплата</span></router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- **** CALENDAR **** -->
                            <div class="mb-5 mb-md-0 d-none d-md-block">
                                <div class="calendar">
                                    <div class="title-4">Выберите срок аренды</div>

                                    <calendar-app></calendar-app>

                                    <div class="selectTimeRentDate">

                                        <div class="as-hr"></div>

                                        <!--                                        <div class="element-wrap">-->
                                        <!--                                            <h6 class="color-text-grey text-uppercase">Количество:</h6>-->
                                        <!--                                            <div class="d-flex align-items-center">-->
                                        <!--                                                <button class="count-btn" @click="count&#45;&#45;"-->
                                        <!--                                                        :disabled="true ? count == 1 || itemFromBasket : count > 1">-->
                                        <!--                                                    <img src="/svg/count-less.svg" alt="">-->
                                        <!--                                                </button>-->
                                        <!--                                                <span class="pl-1 pr-1">{{count}}</span>-->
                                        <!--                                                <button :disabled="itemFromBasket" class="count-btn" @click="count++"><img-->
                                        <!--                                                    src="/svg/count-more.svg" alt=""></button>-->
                                        <!--                                            </div>-->
                                        <!--                                        </div>-->

                                        <div class="element-wrap active">
                                            <div class="h6 color-text-grey text-uppercase">Тариф:</div>

                                            <div v-if="item.discount_flag !== 0">
                                                <span> {{item.discount_new_price}} RUB / день</span>
                                            </div>
                                            <div v-else-if="store.rate.count !== 0">
                                                <span v-if="store.rate.value == 2"> {{item.day_price}} RUB / день</span>
                                            </div>
                                            <div v-else>
                                                <span>—</span>
                                            </div>
                                        </div>

                                        <div class="element-wrap ">
                                            <div class="h6 color-text-grey text-uppercase">Скидка:</div>
                                            <span v-if="item.discount_flag == 1"> 0%</span>
<!--                                            {{ Math.round((item.discount_old_price - item.discount_new_price) * 100 / item.discount_old_price) }}-->
                                            <span v-else-if="item.not_apply_discount == 0">{{store.common_price.discount}}%</span>
                                            <span v-else>0%</span>
                                        </div>

                                        <div class="element-wrap active">
                                            <div class="h4 mb-0 font-700 text-uppercase">ИТОГО:</div>
                                            <div class="color-primary" v-if="item.discount_flag == 1">
                                                {{ getFinalPriceDiscount() }} RUB
                                            </div>
                                            <div class="color-primary" v-else-if="store.rate.count !== 0">
                                                {{getFinalPrice()}} RUB
                                            </div>
                                            <div v-else>
                                                — RUB
                                            </div>
                                        </div>

                                        <button class="button btn-small btn-v2 w-100" v-if="itemFromBasket">Товар в
                                            корзине
                                        </button>
                                        <button id="button" class="Vkorziny button btn-small btn-v2 w-100" v-else
                                                @click="addToBasket('show_modal')">Добавить в корзину
                                        </button>

                                        <div class="set-order" @click="makeOrder()">Оформить заказ</div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <!-- ITEM FULL DESCRIPTION -->
                        <div class="item_information">

                            <div class="mb-32 new-tabs">
                                <div class="d-flex align-items-center justify-content-between new-tabs-titles-wrapper">
                                    <div class="new-tabs-titles new-tabs-titles-card">
                                        <div v-for="(item, i) in description_items" class="new-tabs-title new-tabs-title-card" :class="{'active-card': description_active == item.id}" @click="description_active = item.id"  :key="i">
                                            <span class="title-3 mb-0">{{item.title}}</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="new-tabs-content-wrapper new-tabs-content-wrapper-mtn new-tabs-content-wrapper-card">
                                    <div class="new-tabs-content new-tabs-content-card">

<!--                                        <div v-if="description_active == 1" class="new-tab-content" :class="{'active-content': new_active == 1}">-->
<!--                                            <div class="catalog-container">-->
<!--                                                <div class="news-product" v-if="accessories && accessories.length > 0">-->
<!--                                                    <carousel :responsive="{0:{items:2,nav:false,margin:7,dots:false},-->
<!--                                                    535:{items:3,nav:false,margin:7,dots:false},-->
<!--                                                    991:{items:4,nav:false,margin:7,dots:false},-->
<!--                                                    1200:{items:5,nav:false,margin:7,dots:false, mouseDrag:(accessories.length > 5) ? true : false, touchDrag:(accessories.length > 5) ? true : false}}"-->
<!--                                                              :loop="(accessories.length > 5) ? true : false">-->
<!--                                                        <catalog-card v-for="(item, i) in accessories" :key="i"-->
<!--                                                                      :item="item"></catalog-card>-->
<!--                                                    </carousel>-->
<!--                                                </div>-->
<!--                                                <div class="news-product" v-else>Нет информации</div>-->
<!--                                            </div>-->
<!--                                        </div>-->
                                        <div v-if="description_active == 2" class="new-tab-content" :class="{'active-content': description_active == 2}">
                                            <div class="catalog-container">
                                                <div class="news-product" v-if="item.desc" v-html="item.desc">
                                                </div>
                                                <div class="news-product" v-else>Нет информации</div>
                                            </div>
                                        </div>
                                        <div v-if="description_active == 3" class="characteristics--style new-tab-content" :class="{'active-content': description_active == 3}">
                                            <div class="catalog-container">
                                                <div class="news-product" v-if="item.characteristics" v-html="item.characteristics">
                                                </div>
                                                <div class="news-product" v-else>Нет информации</div>
                                            </div>
                                        </div>
                                        <div v-if="description_active == 4" class="equipment--style new-tab-content" :class="{'active-content': description_active == 4}">
                                            <div class="catalog-container">
                                                <div class="news-product" v-if="item.equipment" v-html="item.equipment">
                                                </div>
                                                <div class="news-product" v-else>Нет информации</div>
                                            </div>
                                        </div>
                                        <div v-if="description_active == 5" class="new-tab-content" :class="{'active-content': description_active == 5}">
                                            <div class="catalog-container">
                                                <div class="news-product" v-if="item.instruction">
                                                    <a :href="'https://app.skybase.ru/public/actions/39947490820098?fileid=' + item.code + '-f71'"
                                                       target="_blank"
                                                       class="card-instr">
                                                        <img src="/svg/document-pdf-red.svg" alt="">
                                                        <span class="pl-1">Открыть инструкцию</span>
                                                    </a>
                                                </div>
                                                <div class="news-product" v-else>Нет информации</div>
                                            </div>

                                        </div>
                                        <div v-if="description_active == 6" class="new-tab-content" :class="{'active-content': description_active == 6}">
                                            <div class="catalog-container">
                                                <div class="news-product" v-if="item.video">
                                                    <iframe width="100%" height="540" :src="item.video"
                                                            frameborder="0"
                                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                            allowfullscreen></iframe>
                                                </div>
                                                <div class="news-product" v-else>Нет информации</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="recommendations">
                            <h2 class="mb-40 text-uppercase">Мы рекомендуем</h2>

                            <div class="catalog-container">
                                <carousel :responsive="{0:{items:2,nav:false,margin:7,dots:false},
                                                    535:{items:3,nav:false,margin:7,dots:false},
                                                    991:{items:4,nav:false,margin:7,dots:false},
                                                    1200:{items:5,nav:false,margin:7,dots:false, mouseDrag:(recommendations.length > 5) ? true : false, touchDrag:(recommendations.length > 5) ? true : false}}"
                                          :loop="(recommendations.length > 5) ? true : false">
                                    <catalog-card v-for="(item, i) in recommendations" :key="i"
                                                  :item="item"></catalog-card>
                                </carousel>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- MODAL WITH IMAGES-->
            <b-modal id="showProductImage"
                     :hide-header="true"
                     :hide-footer="true">
                <div class="hide-area" @click="$bvModal.hide('showProductImage')"></div>
                <div class="close" @click="$bvModal.hide('showProductImage')"><img src="/svg/close.svg" alt=""></div>
                <div class="show-area">
                    <b-carousel
                        id="carouselModal"
                        :interval="0"
                        fade
                        v-model="slide"
                        :controls="true ? item_images.length > 1 : false">
                        <b-carousel-slide v-for="(image, i) in item_images" :key="i">
                            <template #img>
                                <img class="d-block img-fluid"
                                     :alt="'Вы можете взять в аренду' + item.name + 'на сервисе фотопроката MRental'"
                                     :src="'https://app.skybase.ru/public/actions/39947490820098?fileid=' + item.code + image">
                            </template>
                        </b-carousel-slide>
                    </b-carousel>
                </div>
            </b-modal>

            <div v-if="loading" class="loading-box">
                <b-spinner></b-spinner>
            </div>

        </div>

        <add-basket-modal></add-basket-modal>

    </div>
</template>

<script>
    import store from '../../../services/data';
    import filter from "../../../services/filter";

    import carousel from 'vue-owl-carousel'

    export default {
        components: {carousel},

        data() {
            return {
                item: null,
                item_images: null,
                recommendations: null,
                accessories: null,
                delivery: null,

                description_items: [],
                description_active: null,

                store: store,
                filter: filter,

                count: 1,
                itemFromBasket: null,

                slide: 0,
                loading: true
            }
        },

        mounted() {
            this.init();
        },

        methods: {
            setMetaOg(title, desc, image, price) {
                document.querySelector('meta[property="og:type"]').setAttribute("content",  'og:product');
                document.querySelector('meta[property="og:title"]').setAttribute("content",  title);
                document.querySelector('meta[property="og:image"]').setAttribute("content",  image);
                document.querySelector('meta[property="og:description"]').setAttribute("content",  desc);
                document.querySelector('meta[property="og:url"]').setAttribute("content",  window.location.href);
                document.querySelector('meta[property="product:price:amount"]').setAttribute("content",  price);
                document.querySelector('meta[property="product:price:currency"]').setAttribute("content",  'RUB');
            },

            init() {
                this.loading = true;
                let url = '/api/product-info';
                let params = {
                    url: this.$route.path
                };
                axios.post(url, params)
                    .then(response => {
                        this.item = response.data.product;
                        let seoInfo = response.data.seoInfo;
                        this.item.h1 = seoInfo.seo_h1;
                        if (response.data.recommendations && response.data.recommendations.length > 0) this.recommendations = response.data.recommendations;
                        if (response.data.accessories && response.data.accessories.length > 0) this.accessories = response.data.accessories;
                        if (response.data.delivery && response.data.delivery.length) this.delivery = response.data.delivery;

                        /* get images */
                        let images = [];
                        if (response.data.product.main_image) images.push('-f64');
                        if (response.data.product.image2) images.push('-f65');
                        if (response.data.product.image3) images.push('-f66');
                        if (response.data.product.image4) images.push('-f67');
                        this.item_images = images;

                        this.filter.getBreadcrumb(response.data.category, this.item);
                        this.getDescriptionNavigation();
                        this.loading = false;

                        this.itemFromBasket = this.store.checkItemBasket(this.item.code);

                        document.title = seoInfo?.seo_title
                            ? seoInfo.seo_title
                            : (seoInfo?.seo_h1 ?? this.item.name) + ' взять в аренду в Москве, цена';

                        let ogTitle = seoInfo?.seo_title
                            ? seoInfo.seo_title
                            : 'Аренда: ' + (seoInfo?.seo_h1 ?? this.item.name);

                        let desc = seoInfo?.seo_desc
                            ? seoInfo.seo_desc
                            : (seoInfo?.seo_h1 ?? this.item.name) + ' взять в аренду в Москве. ⭐️ Без залога. ⭐️ Только профессиональное оборудование. ⭐️ Доставка по всей Москве.';

                        document.querySelector('meta[name="description"]').setAttribute("content", desc);
                        document.querySelector('meta[name="twitter:description"]').setAttribute("content", desc);
                        document.querySelector('meta[property="og:description"]').setAttribute("content", desc);
                        document.querySelector('meta[name="twitter:text:description"]').setAttribute("content", desc);

                        let image = 'https://app.skybase.ru/public/actions/39947490820098?fileid=' + this.item.code + '-f64';

                        let price = this.item.day_price;

                        if (this.$route.name == 'pages-catalog-show') {
                            this.setMetaOg(ogTitle, desc, image, price);
                        }
                    })
                    .catch(error => {
                        if (error) this.$router.push({ path: '/404' });
                    })

                },

            getDescriptionNavigation() {
                // if (this.accessories) this.description_items.push( {id: 1, title: 'аксессуары'});
                if (this.item.desc) this.description_items.push( {id: 2, title: 'Описание'});
                if (this.item.characteristics) this.description_items.push( {id: 3, title: 'Характеристики'});
                if (this.item.equipment) this.description_items.push( {id: 4, title: 'Комплектация'});
                if (this.item.instruction) this.description_items.push( {id: 5, title: 'Инструкция'});
                if (this.item.video) this.description_items.push( {id: 6, title: 'Видео'});

                // let items = [
                //     {id: 1, title: 'аксессуары'},
                //     {id: 2, title: 'описание'},
                //     {id: 3, title: 'характеристики'},
                //     {id: 4, title: 'комплектация'},
                //     {id: 5, title: 'инструкция'},
                // ];
                //
                //
                // if (this.item.video) {
                //     items.push( {id: 6, title: 'видео'})
                // }
                if (this.description_items.length > 0) {
                    this.description_active = this.description_items[0].id;
                }
                //this.description_items = items
            },

            getFinalPriceDiscount() {
                return this.store.getFinalPrice(this.item.threeHoure_price, this.item.day_price, this.count, this.item.not_apply_number_days, this.item.discount_flag, this.item.discount_new_price);
            },

            getFinalPrice() {
                let price = this.store.getFinalPrice(this.item.threeHoure_price, this.item.day_price, this.count, this.item.not_apply_number_days, false, 0);
                if (this.item.not_apply_discount == 0) return Math.round(price - price * this.store.common_price.discount / 100);
                else return price
            },

            addToBasket(show) {
                let data = {
                    code: this.item.code,
                    // slug: this.item.slug,
                    // name: this.item.name,
                    // main_image: this.item.main_image,
                    // day_price: this.item.day_price,
                    // threeHoure_price: this.item.threeHoure_price,
                    count: this.count,
                };
                this.store.addToBasket(data);
                this.store.state.basket_accessories = this.accessories;
                this.store.state.basket_name = this.item.name;

                //if (show) this.$root.$emit('bv::show::modal', 'addBasketModal', '#button');
                //if (show) this.$root.$emit('bv::show::modal', 'addBasketModal', '#button_mobile');

                this.itemFromBasket = this.store.checkItemBasket(this.item.code);
            },

            makeOrder() {
                if (this.itemFromBasket) this.$router.push({path: '/basket'});
                else {
                    this.addToBasket();
                    this.$router.push({path: '/basket'});
                }
            },

            preventDefault(event) {
                if (event) event.preventDefault();
            },
            slideTo(item) {
                this.slide = item;
            },
            changeActive(item) {
                this.slide = item;
            }
        },

        watch: {
            $route() {
                this.item = null;
                this.item_images = null;
                this.recommendations = null;
                this.accessories = null;
                this.description_items = [];
                this.description_active = null;
                this.count = 1;

                this.init();
            }
        },
    }
</script>
